import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { DrupalService } from 'src/app/services/drupal.service';
import { formatDate } from '@angular/common';

interface SitemapEntry {
  loc: string;
  lastmod?: string;
}

@Component({
  selector: 'app-sitemap',
  templateUrl: './sitemap.component.html',
  styleUrls: ['./sitemap.component.scss']
})
export class SitemapComponent implements OnInit {
  urls: SitemapEntry[] = [];
  totalPages: number = 0;
  currentPage: number = 1;
  @ViewChild('top') scrollToTop: ElementRef | undefined;

  constructor(
    private drupalService: DrupalService,
  ) {}

  ngOnInit() {
    this.loadSitemapIndex();
  }

  loadSitemapIndex() {
    this.drupalService.getSitemap('sitemap.xml').subscribe({
      next: (data: string) => {
        const parser = new DOMParser();
        const xmlDoc = parser.parseFromString(data, 'application/xml');
        const sitemapElements = xmlDoc.getElementsByTagName('sitemap');

        this.totalPages = sitemapElements.length;

        // Load the first page immediately
        this.loadSitemapPage(1);
      },
      error: (error) => {
        console.error('Error fetching sitemap index:', error);
      }
    });
  }

  loadSitemapPage(page: number) {
    this.drupalService.getSitemap(`sitemap.xml?page=${page}`).subscribe({
      next: (data: string) => {
        const parser = new DOMParser();
        const xmlDoc = parser.parseFromString(data, 'application/xml');
        const urlElements = xmlDoc.getElementsByTagName('url');
        
        this.urls = Array.from(urlElements).map(urlElement => {
          const lastmodElement = urlElement.getElementsByTagName('lastmod')[0];
          return {
            loc: urlElement.getElementsByTagName('loc')[0]?.textContent || '',
            lastmod: lastmodElement ? this.formatItalianDate(lastmodElement.textContent!) : undefined
          };
        });

        this.currentPage = page;
      },
      error: (error) => {
        console.error(`Error fetching sitemap page ${page}:`, error);
      }
    });
    this.scrollToTop?.nativeElement.scrollIntoView({ behavior: "smooth" });
  }

  formatItalianDate(isoDateString: string): string {
    try {
      const date = new Date(isoDateString);
      return formatDate(date, 'dd/MM/yyyy HH:mm', 'it-IT');
    } catch {
      return 'Data non disponibile';
    }
  }

  onPageChange(page: number) {
    this.loadSitemapPage(page);
  }
}